import { IFleet } from 'app/shared/model/fleet.model';
import { IStation } from 'app/shared/model/station.model';
import { DeviceType } from 'app/shared/model/enumerations/device-type.model';

export interface IDevice {
  id?: number;
  type?: keyof typeof DeviceType;
  serialNumber?: string;
  model?: string;
  name?: string | null;
  vendorData?: string | null;
  fleet?: IFleet | null;
  station?: IStation | null;
}

export const defaultValue: Readonly<IDevice> = {};
